import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-hebergement',
    templateUrl: './realisation.component.html',
    styleUrls: ['./realisation.component.scss']
})

export class RealisationComponent implements OnInit {
    model = {
        left: true,
        middle: false,
        right: false
    };

    focus;
    focus1;
    constructor() { }

    ngOnInit() {}
}
